import m from 'mithril'
import clsx from 'clsx'
import { initMithrilComponent } from '@client-shared/utils/mithril'

import s from './radial-progress.module.scss'

interface Attrs extends m.Attributes {
	progress_percentage: number
}

const RadialProgress = initMithrilComponent<Attrs>()

RadialProgress.view = (vnode) => {
	const { progress_percentage, class: add_class } = vnode.attrs

	return m(
		'div',
		{
			class: clsx(s.radial_progress, add_class),
			style: { '--value': progress_percentage },
			'aria-valuenow': progress_percentage,
			role: 'progressbar',
		},
		vnode.children,
	)
}

export default RadialProgress
